import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import {Grid, ListItem, Box} from '@material-ui/core'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import Button from '../../components/ButtonCustom';
import Divider from '../../components/Divider';
import { MasterIcon, RadioCheckedIcon, RadioIcon, VisaIcon } from '../../components/icons';
import { LinkRouter } from '../../components/Link';
import { domainName } from '../../../portal.config';
const styles = theme => ({
    container:{
        padding: theme.spacing(6),
    },
    item:{
        marginTop:theme.spacing(4),
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
    },
    form:{
        marginTop: theme.spacing(4)
    },
    boxItemContent: {
        padding: theme.spacing(3,4,3,4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    btn_topup:{
        marginTop: theme.spacing(16)
    },
    card_item: {
        width: '100%',
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.border.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },

    last: {
        width: '100%',
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },

});
function TopupWalletView(props) {
        const { currency, classes, onClose,showLoading, wallet} = props;
       // console.log('amount=====', this.props.amount)
        return (
            <DrawerCustom 
                open={props.open} 
                onClose = {onClose} 
                title = {t('topup_wallet')}
                children={        
                    <Grid item>
                        {showLoading?<Grid xs ={12} item container justify='center'><CustomizedCircularProgress color="primary"/></Grid>:null}
                        <Grid xs={12} item justify='center'>
                            <CustomTypo color='onPrimary' variant='h2' center mg_top_xl>{props.currency}{wallet && wallet.balance ? wallet.balance.toFixed(2) : "0.00"}</CustomTypo>
                            <CustomTypo color='label' variant='body1' center>{t('current_balance')}</CustomTypo>
                        </Grid>
                        <Form
                            onSubmit={domainName=='cignal' ? props.onPayMayaTopup : props.onTopup}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item className={classes.form}>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="amount"
                                            component={TextFieldComponent}
                                            label={t('topup_wallet')}
                                            placeholder={t('enter_amount')}
                                            isEdit={true}
                                            color='default'
                                            valuez = {props.amount}
                                            onCustomChange={props.onChangeInput}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                            
                                        />
                                    </Grid>
                                    <Grid item xs={12} container justifyContent='flex-end'>
                                        <LinkRouter type='body2' size='sm' color='onPrimary' onClick = {()=>props.setShowAutomateWallet(true)}>{t('automatically_topup')} </LinkRouter>
                                    </Grid>
                                    <CustomTypo color='onPrimary' variant='body1' mg_top_xl>{t('recommended')}</CustomTypo>
                                    <Grid item xs={12} container>
                                        <Button color='onPrimary' size='sm' rectangle onClick={()=>props.onChangeInput('5')}>{currency}{'5'}</Button>
                                        <Button color='onPrimary' size='lg' rectangle onClick={()=>props.onChangeInput('10')}>{currency}{'10'}</Button>
                                        <Button color='onPrimary' size='xs' rectangle onClick={()=>props.onChangeInput('20')}>{currency}{'20'}</Button>
                                    </Grid>    
                                    {domainName!='cignal' &&<CustomTypo color='onPrimary' variant='body1' mg_top_xl>{t('debit_from')}</CustomTypo>}
                                    {domainName!='cignal' && <Grid item xs={12} className={classes.boxItemContent}>
                                        {props.cards.length>0?props.cards.map((card, index)=>{
                                        return(
                                                <Grid xs={12} key={index} item container alignItems='center' className={index === props.cards.length-1?classes.last : classes.card_item} onClick={() => props.setCardSelect(card)}>
                                                    <Grid xs={2} sm={2} item>
                                                        {card.brand ==='master'? <MasterIcon/>:<VisaIcon/>}
                                                    </Grid>
                                                    <Grid xs={6} sm={7} item>
                                                    <CustomTypo mg_left_xs variant='body1'>**** **** **** {card && card.card && card.card.last4 ? card.card.last4 : ''}</CustomTypo>
                                                    </Grid>
                                                    <Grid xs={4} sm={3} item justify='flex-end' container>
                                                        {props.cardSelect.id === card.id ? <RadioCheckedIcon /> : <RadioIcon/>}
                                                    </Grid>
                                                </Grid>
                                                )
                                         }):<Grid item xs={12} onClick={props.onShowAddCard}>
                                                <CustomTypo mg_left_xs variant='body1'>+ {t('add_a_card')}</CustomTypo>
                                             </Grid>}

                                     </Grid>   }
                                    

                                    <Grid xs={12} item container justify='center' className={classes.btn_topup}>
                                        <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_submit')}</Button>
                                    </Grid>
                                </Grid>
                            )} />
               </Grid>}/>
        );
}

export default withStyles(styles)(withTranslation()(TopupWalletView));